import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import React from 'react';

const CustomTextField = ({id, label, disabled, value, onChange, error, helperText, minWidth, type, multiline}) => {
  return (
    <FormControl size="small" sx={{m: 1, minWidth}}>
      <TextField
        id={id}
        type={type || 'text'}
        label={label}
        variant="outlined"
        size="small"
        disabled={disabled}
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
        multiline={multiline || false}
      />
    </FormControl>
  );
};

export default CustomTextField;
